import { CHILDREN_AGE_RANGE, MAX_TRAVELLERS } from '../blocks/Travellers/Travellers';

export const checkIfChildrenAgesAreValid = (childrenAgesValues: string[]) => {
  return (
    Array.isArray(childrenAgesValues) &&
    childrenAgesValues.every(
      (age) => /^\d{1,2}$/g.test(age) && Number(age) < CHILDREN_AGE_RANGE.end
    )
  );
};

export const checkIfAdultsAreValid = (adultsValue: string) => {
  return (
    /^\d$/g.test(adultsValue) && Number(adultsValue) > 0 && Number(adultsValue) <= MAX_TRAVELLERS
  );
};

export const checkIfDateIsValid = (dateValue: string | null) => {
  return (
    dateValue === null ||
    (/^\d{4}-\d{2}-\d{2}$/g.test(dateValue) && !!new Date(dateValue).getDate())
  );
};

export const checkIfGeoIdIsValid = (idValue?: string) => {
  // Отсутствие geoId считаем валидным кейсом. Такое поведение требуется для формы на SEO страницах.
  return !idValue || /^\d+$/g.test(idValue);
};
